import React from "react";

const AccountIcon = props => (
  <svg
    style={props.style}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M10 19.375a9.375 9.375 0 100-18.75 9.375 9.375 0 100 18.75zM16.644 16.613l-4.769-2.238M8.125 14.375l-4.769 2.238"
    ></path>
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M11.875 14.375c1.881-1.45 1.875-4.025 1.875-4.025v-3.3c-.269-1.519-2.106-2.675-3.75-2.675-1.644 0-3.481 1.156-3.75 2.675v3.3s0 2.569 1.875 4.019"
    ></path>
  </svg>
);

export default AccountIcon;



// WEBPACK FOOTER //
// ./src/icons/AccountIcon.jsx